var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _c("span", { staticClass: "subheader" }, [_vm._v("Global Summary")]),
      ]),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.continents,
          "item-key": "region_key",
          "hide-default-footer": "",
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  {
                    on: {
                      click: function ($event) {
                        props.expanded = !props.expanded
                      },
                    },
                  },
                  [
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.region_name)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(_vm._f("pounds")(props.item.invoices))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(_vm._f("pounds")(props.item.payments))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(_vm._f("pounds")(props.item.balance))),
                    ]),
                  ]
                ),
              ]
            },
          },
          {
            key: "expand",
            fn: function (props) {
              return [_c("h1", [_vm._v(_vm._s(props.item.region_key))])]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }